var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgSmallProfilePic = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "#F56B57"
}, /*#__PURE__*/React.createElement("path", {
  d: "M15.044 10.247a3.91 3.91 0 1 0-5.528-5.529 3.91 3.91 0 0 0 5.528 5.529M15.156 12c-1.531 1.91-4.459 1.836-5.89-.151a8.32 8.32 0 0 0-5.601 7.865c5.489.921 10.834.981 16.637 0 .343-3.464-1.973-6.468-5.146-7.714"
}))));
export default SvgSmallProfilePic;